import type { PuUrgencyStyle, PuUrgencyTier } from './types';

export const PU_GOLD_GRAD =
  'linear-gradient(135deg, color-mix(in srgb, var(--gold) 70%, #fff), var(--gold))';

export const PU_URGENCY: Record<PuUrgencyTier, PuUrgencyStyle> = {
  high: {
    bg: 'var(--terracotta-tint)',
    fg: 'var(--terracotta)',
    border: 'color-mix(in srgb, var(--terracotta) 24%, transparent)',
    icon: 'alert',
    highlight: 'var(--terracotta)',
  },
  medium: {
    bg: 'var(--gold-tint)',
    fg: 'var(--gold)',
    border: 'color-mix(in srgb, var(--gold) 26%, transparent)',
    icon: 'shield',
    highlight: 'var(--gold)',
  },
  standard: {
    bg: 'var(--surface-mute)',
    fg: 'var(--ink-2)',
    border: 'var(--cream-2)',
    icon: 'check-circ',
    highlight: 'var(--success)',
  },
};
